import MobileCoverageRating from './MobileCoverageRating';

export default MobileCoverageRating;
